(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-gemius"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-gemius"] = factory(root["mggp-player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_mggp_player__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/mggp-plugin-gemius.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/mggp-plugin-gemius.js":
/*!***********************************!*\
  !*** ./src/mggp-plugin-gemius.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mggpPlayer = __webpack_require__(/*! mggp-player */ "mggp-player");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protocol = 'http' + (location.protocol == 'https:' ? 's' : '');

/**
 * @class MggpPluginGemius
 */

var MggpPluginGemius = function (_Plugin) {
  _inherits(MggpPluginGemius, _Plugin);

  function MggpPluginGemius() {
    var _ref;

    _classCallCheck(this, MggpPluginGemius);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = MggpPluginGemius.__proto__ || Object.getPrototypeOf(MggpPluginGemius)).call.apply(_ref, [this].concat(args)));

    if (!_this.config.gemius || !_this.config.gemius.prefix || !_this.config.gemius.identifier) return _possibleConstructorReturn(_this);

    _this.namespace = 'gemius:';

    _this._playerId = 'player_' + Math.round(Math.random() * 10000000);
    _this._hitCollector = protocol + '://' + _this.config.gemius.prefix + '.hit.gemius.pl';
    _this._videoId = null;
    _this._customPackage = [];
    _this._additionalPackage = [];
    _this._treeId = [100];

    if (window.gemiusStream) {
      _this._listen();
    } else {
      var script = document.createElement('script');
      script.onload = _this._listen.bind(_this);
      script.async = script.defer = true;
      script.src = _this._hitCollector + '/gstream.js';
      document.body.appendChild(script);
    }
    return _this;
  }

  /**
   * Bind player events
   */


  _createClass(MggpPluginGemius, [{
    key: '_listen',
    value: function _listen() {
      var _this2 = this;

      this.player.on('player:mediaCanPlay', function () {
        var videoInfo = _this2.player.get('videoInfo');
        _this2._videoId && _this2._closeStream();
        _this2._videoId = videoInfo.video_id;
        _this2._customPackage = [{ name: 'CNAME', value: videoInfo.title }];
        _this2._createStream();
      });

      this.player.on('player:stateChange', function () {
        switch (_this2.player.get('state')) {
          case 0:
            _this2._hit('complete');break;
          case 1:
            _this2._hit('playing');break;
          case 2:
            _this2._hit('paused');break;
        }
      });

      this.player.on('player:mediaSeekStart', function () {
        return _this2._hit('seekingStarted');
      });
      this.player.on('player:bufferingStart', function () {
        return _this2._hit('buffering');
      });

      this.player.on('player:mediaSeekEnd', function () {
        if (_this2.player.get('state') === 1) _this2._hit('playing');
      });

      this.player.on('player:bufferingEnd', function () {
        if (_this2.player.get('state') === 1) _this2._hit('playing');
      });
    }

    /**
     * Init new material
     */

  }, {
    key: '_createStream',
    value: function _createStream() {
      if (window.gemiusStream) {
        window.gemiusStream.newStream(this._playerId, this._videoId, this.player.get('duration'), this._customPackage, this._additionalPackage, this.config.gemius.identifier, this._hitCollector, this._treeId);
      }
    }

    /**
     * Send material event
     * @param  {string} eventType
     */

  }, {
    key: '_hit',
    value: function _hit(eventType) {
      if (window.gemiusStream) {
        window.gemiusStream.event(this._playerId, this._videoId, this.player.get('position'), eventType);
      }
    }

    /**
     * Close current stream
     */

  }, {
    key: '_closeStream',
    value: function _closeStream() {
      if (window.gemiusStream) {
        window.gemiusStream.closeStream(this._playerId, this._videoId, this.player.get('position'));
      }
    }

    /**
     * Destructor
     */

  }, {
    key: 'dispose',
    value: function dispose() {
      this._closeStream();
    }
  }]);

  return MggpPluginGemius;
}(_mggpPlayer.Plugin);

exports.default = MggpPluginGemius;

/***/ }),

/***/ "mggp-player":
/*!******************************!*\
  !*** external "mggp-player" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_mggp_player__;

/***/ })

/******/ });
});